import React, { useState } from 'react'
import { useMount } from 'react-use'
import { isFunction } from 'lodash'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { getFullPath } from 'lib/location'

import ControlledModal from './ControlledModal'

const ModalStateRender = () => {
    const match = useRouteMatch()
    const history = useHistory()
    const [modal] = useState(window.__mv_modal ? window.__mv_modal[match.params.id] : null)

    useMount(() => {
        if (!modal) {
            history.push(getFullPath(history.location, { hash: false }))
        }
    })

    return modal ? (
        <ControlledModal
            routedModal
            name="modal-state-render"
            context={modal.id}
            initialTitle={modal.title}
            requireUserInput={false}
        >
            {(modalProps) => isFunction(modal.content) ? modal.content(modalProps) : modal.content}
        </ControlledModal>
    ) : null
}

export default ModalStateRender
